<template>
  <div :class="`vue-filter ${name}-filter`" v-click-outside="onClickOutside">
    <label v-if="label">{{ label }}</label>
    <div class="filter-wrapper">
      <div
        class="multiselect-dropdown form-control"
        :id="name"
      >
        <div class="multiselect-selected" @click="toggleDropdown">
          <span v-if="model.length > 0">
            {{ selectedLabels }}
          </span>
          <span v-else>{{ placeholder }}</span>
        </div>
        <div class="multiselect-options" v-show="dropdownOpen">
          <CheckboxGroup
            :name="name"
            v-model:value="model"
            :options="options"
            :enable-search="false"
            :enable-select-all="false"
          ></CheckboxGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxGroup from "@/components/Form/CheckboxGroup"
import vClickOutside from "click-outside-vue3"

export default {
  name: "MultiSelectFilter",
  emits: ["update"],
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    CheckboxGroup,
  },
  props: {
    name: {
      type: String,
      required: true,
      default: () => "filter"
    },
    label: {
      type: String,
      required: false,
      default: () => ""
    },
    value: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    options: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    list: {type: Object},
    placeholder: {
      type: String,
      required: false,
      default: () => ""
    },
  },
  data() {
    return {
      dropdownOpen: false,
      model: this.value,
      state: {
        search: {
          loading: false
        }
      },
      config: {
        debounce: 600,
        inputClass: ["form-control"],
      },
      search: {
        query: "",
      },
      Drupal: this.$drupal,
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(item => {
        return item.label.toLowerCase().includes(this.search.query.toLowerCase())
      })
    },

    selectedOptions() {
      return this.options.filter(option => {
        return (this.model || []).includes(option.id)
      })
    },

    selectedLabels() {
      return this.selectedOptions
        .map(option => option.label)
        .join(", ");
    },
  },
  watch: {
    model: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.updateValue()
        }
      },
    },
    value: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.model = to
        }
      },
    },
  },
  methods: {
    updateValue() {
      this.$emit("update", this.model);
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    onClickOutside() {
      this.dropdownOpen = false;
    },
  }
}
</script>
